import { render, staticRenderFns } from "./courier.vue?vue&type=template&id=3ec57dca&"
import script from "./courier.vue?vue&type=script&lang=js&"
export * from "./courier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports